"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_utils_1 = require("../../utils/dom-utils");
const media_queries_1 = require("../../utils/media-queries");
const entrySection = () => {
    const fallingSections = (0, dom_utils_1.queryAll)("[data-falling]");
    fallingSections.forEach(section => {
        let lastScrollPos = window.scrollY;
        const observerConfig = window.devicePixelRatio === 1
            ? { rootMargin: "0px", threshold: 0.125 }
            : { rootMargin: "0px" };
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const section = entry.target;
                const currentScrollPos = window.scrollY;
                if (entry.isIntersecting) {
                    currentScrollPos < lastScrollPos ?
                        animateSection(section, "animate") :
                        animateSection(section, "animate-reverse");
                    observer.unobserve(section);
                }
                lastScrollPos = currentScrollPos;
            });
        }, observerConfig);
        observer.observe(section);
    });
};
const animateSection = (section, animationClass) => {
    section.classList.add(animationClass);
};
document.addEventListener("DOMContentLoaded", () => {
    if (window.matchMedia(media_queries_1.mediaQueries.maruda).matches)
        entrySection();
});
window.addEventListener("resize", () => entrySection());
